<template>
  <div class="homePage02Box" :style="bg">
    <!-- 头部导航 -->
    <div class="t_bar">
      <!-- 白色logo -->
      <div class="t_placeholder">
        <!-- 白色/蓝色图标 -->
        <div class="t_icon t_icon_search02" @click="$emit('openSearch')"></div>
        <div class="t_menu pointer t_menu_blue" @mouseenter="$emit('openMenu')">
          <div class="t_menuitem"></div>
          <div class="t_menuitem t_menuitem2"></div>
          <div class="t_menuitem"></div>
        </div>
      </div>
      <div alt="" class="t_logo t_logo03" />
      <div class="t_right t_blue">
        <div class="mN_lage pointer"></div>
        <div class="mN_lag pointer">
          <div class="text">CN</div>
        </div>
      </div>
    </div>
    <div class="content" style="max-width: 1400px">
      <div class="t_title">
        <div class="t_titleText">{{ title }}</div>
        <!-- <div class="t_titleBorder"></div>
        <div class="t_titleEng">PROFESSIONAL</div> -->
      </div>
      <div class="dynamicBox">
        <div class="left" :style="'background: url(' +
          imgUrl +
          $tools.localStorageFn.get('PAGE_DATE').banner1_lef +
          ') no-repeat center center'
          ">
          <p>{{ title }}</p>
          <h2>
            {{
              $tools.localStorageFn.get("PAGE_DATE").dynamicList[
                selectObject - 1
              ].title
            }}
          </h2>
          <button @click="
          $tools.blankPush(
            '/jingzheDynamicDetail?id=' +
            $tools.localStorageFn.get('PAGE_DATE').dynamicList[
              selectObject - 1
            ].id
          )
            ">
            了解更多
          </button>
        </div>
        <div class="right">
          <div class="dynamicItem" :class="selectObject == item ? 'selected' : ''" v-for="(item, index) in $tools.localStorageFn
            .get('PAGE_DATE')
            .dynamicList.slice(0, 3)" :key="item.id" @mouseover="selectObject = index + 1">
            <div class="date">{{ item.created_at.substring(0, 10) }}</div>
            <div class="label">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <!-- 底部提示 -->
      <div class="b_right_icon t_icon_backTop02" @click="() => {
        $emit('move', 1);
      }
        "></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectObject: 1,

      bg: {
        background:
          "url(" +
          this.$tools.localStorageFn.get("PAGE_DATE").banner1 +
          ") no-repeat center center",
      },
      title: ''
    };
  },
  created() {
    this.getTitle(47)
  },
  methods: {

    getTitle(id) {
      this.$tools.localStorageFn.get("CATEGORIES_LIST").forEach((item) => {
        if (item.id == id) {
          console.log('item', item)
          this.title = item.title;
        } else if (item.children.length > 0) {
          item.children.forEach((ele) => {
            console.log('ele', ele)
            if (ele.id == id) {
              this.title = ele.title;
            }
          })
        }
      })
    },
  }
};
</script>

<style lang="scss">
.homePage02Box {
  height: 100%;
  width: 100%;
  // background: url(~@/assets/images/homeBg02.jpg) no-repeat center center;
  background-size: cover !important;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  .t_bar {
    z-index: 200;
    position: absolute !important;
    top: 6rem;
    left: 0;
    width: 100%;
    padding: 0 8rem;
    display: flex;
    justify-content: space-between;

    .t_logo {
      width: 20.5rem;
      height: 4.5rem;
    }

    .t_logo02 {
      background: url(~@/assets/images/logo02.png) no-repeat center center;
      background-size: cover;
    }

    .t_logo03 {
      background: url(~@/assets/images/logo03.png) no-repeat center center;
      background-size: cover;
    }

    .t_placeholder {
      height: 4.5rem;
      display: flex;
      align-items: center;

      span {
        cursor: pointer;
      }

      .t_icon {
        cursor: pointer;
        width: 2.8rem;
        height: 2.8rem;
        display: inline-block;
        // margin-left: 3.4rem;
      }

      .t_menu {
        height: 2.6rem;
        margin: 0 3.5rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .t_menuitem {
          width: 2.8rem;
          height: 0.3rem;
          background: #fff;
        }

        .t_menuitem2 {
          // margin: calc((100% - 5..7rem) / 2) auto;
        }
      }

      .t_menu_blue {
        .t_menuitem {
          background: #013060;
        }
      }

      .t_menu:hover .t_menuitem2 {
        transform: translateX(-50%);
      }
    }

    .t_right {
      font-size: 2rem;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: #ffffff;
      line-height: 4.1rem;
      display: flex;
      align-items: center;

      span {
        cursor: pointer;
      }

      .t_icon {
        cursor: pointer;
        width: 2.8rem;
        height: 2.8rem;
        display: inline-block;
        margin-left: 3.5rem;
      }

      .t_menu {
        height: 2.6rem;
        margin-left: 4.3rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .t_menuitem {
          width: 2.8rem;
          height: 0.3rem;
          background: #fff;
        }

        .t_menuitem2 {
          // margin: calc((100% - 5..7rem) / 2) auto;
        }
      }

      .t_menu_blue {
        .t_menuitem {
          background: #013060;
        }
      }

      .t_menu:hover .t_menuitem2 {
        transform: translateX(-50%);
      }

      .t_icon_menu {
        background: url(~@/assets/images/icon_menu.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_menu02 {
        background: url(~@/assets/images/icon_menu02.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_search01 {
        background: url(~@/assets/images/icon_search01.png) no-repeat center center;
        background-size: 100% 100%;
      }

      .t_icon_search02 {
        background: url(~@/assets/images/icon_search02.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }

    .t_blue {
      color: #013060 !important;
    }
  }

  .t_title {
    // margin: 6.0rem 0;
    margin-bottom: 7.6rem;

    .t_titleText {
      font-size: 6.4rem;
      font-family: JingZhe_XiaoWei;
      font-weight: 400;
      color: #013060;
      // line-height: 3.2rem;
    }

    .t_titleBorder {
      width: 10rem;
      height: 0.3rem;
      background: #013060;
      margin: 1rem auto 1.3rem;
    }

    .t_titleEng {
      font-size: 2.4rem;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: #013060;
      line-height: 1.9rem;
    }
  }

  .content {
    width: 135rem;

    .dynamicBox {
      height: 48.75rem;
      display: flex;

      .left {
        height: 100%;
        width: 76.375rem;
        background-size: 100% 100% !important;
        padding: 5.1rem 3.4rem;

        p {
          margin: 0;
          font-size: 2.2rem;
          font-family: SimHei;
          font-weight: 400;
          color: #013060;
        }

        h2 {
          margin: 0;
          margin-top: 3.3rem;
          font-size: 3.3rem;
          font-family: SimHei;
          font-weight: 400;
          color: #013060;
        }

        button {
          padding: 0;
          cursor: pointer;
          margin-top: 3rem;
          width: 19.2rem;
          height: 4.7rem;
          background: url(~@/assets/images/icon_liaojiegengduo.png) no-repeat center center;
          background-size: 100%;
          font-size: 2rem;
          font-family: SimHei;
          font-weight: 400;
          color: #013060;
          line-height: 4.7rem;
          text-align: center;
          position: relative;
          transition: 0.6s;
          border: 0;
        }

        button:hover {
          color: #fff;
          background: url(~@/assets/images/icon_liaojiegengduo02.png) no-repeat center center;
          background-size: 100%;
        }
      }

      .right {
        height: 100%;
        width: 59rem;

        .dynamicItem {
          cursor: pointer;
          height: calc(100% / 3);
          padding: 3.3rem 2.8rem 0;
          background: #013060;

          .date {
            font-size: 2rem;
            font-family: SimHei;
            font-weight: 400;
            color: #ffffff;
          }

          .label {
            margin-top: 2.3rem;
            font-size: 2.2rem;
            font-family: SimHei;
            font-weight: 400;
            color: #ffffff;
          }
        }

        .selected {
          background: #01407e;
        }

        .dynamicItem:hover {
          background: #01407e;
        }
      }
    }
  }

  @media screen and (min-width: 1920px) {
    .t_bar {
      top: 60px;
      padding: 0 80px;

      .t_logo {
        width: 205px;
        height: 45px;
      }

      .t_placeholder {
        height: 45px;

        .t_icon {
          width: 28px;
          height: 28px;
        }

        .t_menu {
          height: 26px;
          margin: 0 35px;

          .t_menuitem {
            width: 28px;
            height: 03px;
          }
        }
      }

      .t_right {
        font-size: 20px;
        line-height: 41px;

        .t_icon {
          width: 28px;
          height: 28px;
          margin-left: 35px;
        }

        .t_menu {
          height: 26px;
          margin-left: 43px;

          .t_menuitem {
            width: 28px;
            height: 03px;
          }
        }
      }
    }

    .t_title {
      margin-bottom: 76px;

      .t_titleText {
        font-size: 64px;
      }

      .t_titleBorder {
        width: 100px;
        height: 3px;
        margin: 10px auto 13px;
      }

      .t_titleEng {
        font-size: 24px;
        line-height: 19px;
      }
    }

    .content {
      width: 1400px;

      .dynamicBox {
        height: 510px;

        .left {
          height: 100%;
          width: 800px;
          padding: 51px 34px;

          p {
            font-size: 22px;
          }

          h2 {
            margin-top: 33px;
            font-size: 33px;
          }

          button {
            margin-top: 30px;
            width: 192px;
            height: 47px;
            font-size: 20px;
            line-height: 47px;
          }
        }

        .right {
          width: 600px;

          .dynamicItem {
            padding: 33px 28px 0;

            .date {
              font-size: 20px;
            }

            .label {
              margin-top: 23px;
              font-size: 22px;
            }
          }
        }
      }
    }
  }
}

.active {
  .homePage02Box {
    .left {
      animation-name: fade-in-left96;
      animation-duration: 0.75s;
      animation-timing-function: linear;
      animation-delay: 0s;
      animation-iteration-count: 1;
      animation-direction: normal;
      animation-fill-mode: none;
    }

    .right {
      animation-name: fade-in-right96;
      animation-duration: 0.75s;
      animation-timing-function: ease;
      animation-delay: 0s;
      animation-iteration-count: 1;
      animation-direction: linear;
      animation-fill-mode: none;
    }
  }
}
</style>